import { useState } from "react";
import useStore from "../store/store";

const AddExistingPatient = () => {
  const [query, setQuery] = useState("");
  // from zustand
  const { patient, fetchPatientByUID, setPatient } = useStore();
  const [showMessage, setShowMessage] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const handleSearch = async () => {
    if (!query.trim()) return;
    await fetchPatientByUID(query.trim());
  };

  const updatePatient = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/patients/uid/${patient.uid}`,
        {
          method: "PUT",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({}),
        }
      );
      console.log("Response ", response);
      if (response.ok) {
        const updatedPatient = await response.json();

        setShowMessage(true);
        setStatusMessage("Patient linked to you successfully");
        setTimeout(() => {
          setStatusMessage("");
          setShowMessage(false);
        }, 3000);
        console.log("Patient updated successfully ", updatedPatient);
        setPatient(null);
      } else {
        setShowMessage(true);
        setStatusMessage("Failed linking the patient to you");
        setTimeout(() => {
          setStatusMessage("");
          setShowMessage(false);
        }, 3000);
        console.log("Failed to update the patient ", response.statusText);
      }
    } catch (error) {
      setShowMessage(true);
      setStatusMessage("Error updating patient");
      setTimeout(() => {
        setStatusMessage("");
        setShowMessage(false);
      }, 3000);
      console.error("Error updating patient ", error);
    }
    setQuery("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSearch();
  };
  return (
    <div className="pageContainer">
      <div className="patientHeader">
        {showMessage && (
          <div className="popUpContainer">
            {statusMessage && (
              <div className="popUp">
                <p className="h2">{statusMessage}</p>
              </div>
            )}
          </div>
        )}
        <div className="h2 row space-between pageHeader centerAlign">
          <div>Add an existing patient</div>
        </div>
        <div className="pageHeader ">
          <div className="h3">Please provide any of the following details</div>
          <div className="row centerAlign">
            <div className="h4">Patient UID No</div>
            <div className="col" style={{ marginLeft: "5rem" }}>
              <input
                type="text"
                placeholder="UID"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <div className="b3 midGray">Press Enter after UID input</div>
            </div>
          </div>{" "}
          {patient && (
            <div className="b2 midGray" style={{ marginTop: "1rem" }}>
              <p>Name: {patient.firstName}</p>
              <p>Email: {patient.email}</p>
              <p>UID: {patient.uid}</p>
            </div>
          )}
          <div>
            <button
              className="button1 h3"
              disabled={!patient}
              onClick={updatePatient}
            >
              ADD PATIENT
            </button>
            <button
              className="button2 h3"
              onClick={() => {
                setPatient(null);
                setQuery("");
              }}
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddExistingPatient;
